<template>
    <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.collapse3 variant="secondary">
                Forcing Lags
                <span class="when-opened">
                    <font-awesome-icon icon="chevron-down" />
                </span>
                <span class="when-closed">
                    <font-awesome-icon icon="chevron-right" />
                </span>
            </b-btn>
        </b-card-header>
        <b-collapse id="collapse3" role="tabpanel">
            <b-card-body class="input">
                <div class="flex-container-outer">
                    <div class="flex-container" id="enso">
                        <label for="enso">El Niño</label>
                        <input type="number" value="0" v-model.number="enso[0]" min="0" max="200" required>
                        <input type="number" value="3" v-model.number="enso[1]" min="0" max="200" required>
                        <input type="number" value="10" v-model.number="enso[2]" min="0" max="200" required>
                    </div>

                    <div class="flex-container" id="volcanic">
                        <label for="volcanic">Volcanic</label>
                        <input type="number" value="3" v-model.number="volc[0]" min="0" max="200" required>
                        <input type="number" value="10" v-model.number="volc[1]" min="0" max="200" required>
                    </div>

                    <div class="flex-container" id="solar">
                        <label for="solar">Solar</label>
                        <input type="number" value="1" v-model.number="sol[0]" min="0" max="200" required>
                    </div>

                    <div class="flex-container" id="anth">
                        <label for="anth">Anthropogenic</label>
                        <input type="number" value="0" v-model.number="anth[0]" min="0" max="200" required>
                    </div>
                </div>
                <div style="color: #dc0000;" v-if="invalidInput()">Lag inputs must be between 0 and 200</div>
                <div id="update">
                    <b-button variant="primary" v-on:click=update() :disabled="invalidInput()">Update</b-button>
                    <b-button id="btnReset" variant="secondary" v-on:click=reset()>Reset</b-button>
                </div>

            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
    export default {
        name: "LagsInput",

        data() {
            return { enso: [0, 3, 10],  volc: [3, 10], sol: [1], anth: [0] }
        },

        methods: {
            update: function () {
                this.$emit("updateLags", {enso: this.enso, volc: this.volc, sol: this.sol, anth: this.anth});
            },

            reset: function () {
                this.enso = [0, 3, 10];  this.volc = [3, 10]; this.sol = [1]; this.anth = [0];
                this.update();
            },

            invalidInput() {
                return !(this.isBetween(this.enso[0]) && this.isBetween(this.enso[1]) && this.isBetween(this.enso[2])
                    && this.isBetween(this.volc[0]) && this.isBetween(this.volc[1])
                    && this.isBetween(this.sol[0]) && this.isBetween(this.anth[0]));
            },

            isBetween(input){
                return typeof input === "number" && input >= 0 && input <= 200;
            }
        },
    }
</script>

<style scoped>

    .flex-container-outer {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .flex-container {
        display: flex;
        flex-direction: column;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

    input {
        outline-width: 2px;
        width: 110px;
    }

    input:invalid {
        border-width: thin;
        border-color: rgba(255, 0, 0, 0.62);
        outline-color: rgba(255, 0, 0, 0.62);
    }

    #update {
        margin-top: 1%;
    }

    #btnReset {
        margin-left: 0.3%;
    }

</style>
